import React from "react";
import Table from "../../common-components/table/table";
import { getTableData } from "./helpers";
import { IGetSimulationsData } from "../../../../../services/ClientsDashboardServices.dto";

const SimulationsTable = ({ data }: { data: IGetSimulationsData }) => {
  const { headRow, bodyRows, footerRow } = getTableData(data);

  return <Table headRow={headRow} bodyRows={bodyRows} footerRow={footerRow} />;
};

export default SimulationsTable;
